module.exports = __webpack_public_path__ + "img/chambre2.f8000a47.jpg";